<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";
import { required } from "vuelidate/lib/validators";
Vue.component("v-select", vSelect);
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// import createNumberMask from "text-mask-addons/dist/createNumberMask";
// import MaskedInput from "vue-text-mask";
import moment from "moment";

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Información del producto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // "masked-input": MaskedInput,
  },
  data() {
    return {
      variosmodelos: [],
      datosExistencia: {
        id: "",
        departamento: "",
        stock: "",
        stockOriginal: "",
        cantidad: "",
        razon: "",
      },
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      datos: [],
      stock: [],
      arrayEstante: [],
      url: 0,
      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          dataClass: "text-muted",
          width: "5%",
        },
        {
          name: "bodega.tienda.nombre_tienda",
          sortField: "bodega.tienda.nombre_tienda",
          title: "Sucursal",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "bodega.nombre_bodega",
          sortField: "bodega.nombre_bodega",
          title: "Ubicación",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "existencia",
          sortField: "existencia",
          title: "Existencia",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      // mask_quetzal: createNumberMask({
      //   prefix: "Q ",
      //   suffix: "",
      //   includeThousandsSeparator: true,
      //   thousandsSeparatorSymbol: ",",
      //   allowDecimal: true,
      //   decimalSymbol: ".",
      //   decimalLimit: 2, // how many digits allowed after the decimal
      //   integerLimit: 10, // limit length of integer numbers
      //   allowNegative: false,
      //   allowLeadingZeroes: false,
      // }),
      apiUrl: process.env.VUE_APP_URL,
      formget: {
        descripcion: "",
        precio_compra: "",
        precio_venta: "",
        pasillo: "",
        seccion: "",
        estante: "",
        departamentoId: "",
        id: 0,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],

      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,

      showModalL: false, //Loading
      showModalU: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
       showModalM: false, 
      data: [],
    };
  },
  validations: {
    formget: {
      pasillo: { required },
      seccion: { required },
      estante: { required },
    },
    datosExistencia: {
      cantidad: { required },
      razon: { required },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    // console.log(usuario)
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          console.log('entra al catch')
          this.logout();
          location.reload();
        });
    }
    this.detallPresentacion();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    editarExistencia() {
      let me = this;
      this.$v.datosExistencia.$touch();
      const { cantidad, razon, id, stock,stockOriginal } = this.datosExistencia;
      // console.log(cantidad,  stockOriginal);

      if (cantidad <= 0 || razon == "") {
        Vue.toasted.error(
          "La cantidad debe ser mayor a cero y la razón no puede estar vacía",
          this.options
        );
        return;
      }
      axios
        .put(
          process.env.VUE_APP_URL + "productos/bodegas/update",
          {
            id: id,
            idproducto : stock,
            cantidad_original: stockOriginal,
            cantidad: cantidad,
            descripcion: razon,
            usuario: this.userT.id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          me.$v.$reset();
          me.datosExistencia = {
            id: "",
            departamento: "",
            stock: "",
            stockOriginal: "",
            cantidad: "",
            razon: "",
          };
          me.detallPresentacion();
          Vue.toasted.success("Existencia editada", me.options);
          me.$bvModal.hide("modalEditarExistencia");
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        });
    },
    async selectOpc(action) {
      if (action == 1) {
        let me = this;
        this.arrayEstante = [];
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL +
              "departamentos/estante/busqueda?departamento=" +
              this.formget.departamentoId,
            {
              headers: { "x-token": this.userT.token },
            }
          );
          me.arrayEstante = response.data.data;
        } catch (error) {
          console.log(error);
        }
      }
    },

    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    //Detalle Presentacion
    detallPresentacion() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/viewProducto?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          // console.log(response.data)
          this.datos = response.data.data;
          this.stock = response.data.data.inventario_productos;
          // this.url = response.data.stock.productoId;
          // console.log(    this.stock);
        });
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    async modelos_s() {
      this.showModalM = true;
      const response = await axios.get(process.env.VUE_APP_URL + "productos/stock/ver_modelos?id=" + this.$route.params.id, {
        headers: {"x-token": this.userT.token}
      });
      this.variosmodelos = response.data.data;
   
      // console.log(this.variosmodelos)
      return 0;
    },
    //guardar el registro
    save() {
      const { pasillo, seccion, estante, id } = this.formget;
      const me = this;

      axios
        .post(
          process.env.VUE_APP_URL + "productos/stock/estante",
          {
            pasillo,
            seccion,
            estante: estante.id,
            id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Actualizado", this.options);
          this.detallPresentacion();

          this.showModalU = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          me.$refs.vuetable.refresh();
        });
    },
    //Desactivar registro
    desactivate() {
      const { id, nombre, cantidaddepa } = this.formSub;
      console.log(id);
      axios
        .put(
          process.env.VUE_APP_URL + "productos/bodegas/desactivate",
          {
            idproducto: parseInt(this.$route.params.id),
            id: id,
            cantidad: parseInt(cantidaddepa),
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + " Desactivado", this.options);
          this.detallPresentacion();
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //Activar registro
    activate() {
      const { id, nombre } = this.formSub;
      axios
        .put(
          process.env.VUE_APP_URL + "productos/stock/detalle/activate",
          {
            auto: parseInt(this.$route.params.id),
            id: id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " Activado", this.options);
          this.detallPresentacion();
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },

    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear");
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formSub.id = 0;
      this.formSub.nombre = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showmodalL = false;
          break;
        }
      }
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "desactivate-item") {
        console.log(data);
        this.formSub.nombre = data.bodega.nombre_bodega;
        this.formSub.id = data.id;
        this.formSub.cantidaddepa = data.existencia;
        this.showModalD = true;
      }
      if (action == "edit-item") {
        console.log(data);
        this.datosExistencia.id = data.id;
        this.datosExistencia.stock = data.productoId;
        this.datosExistencia.stockOriginal = data.existencia;
        this.datosExistencia.cantidad = data.existencia;
        this.datosExistencia.razon =
          "Cambio de existencia el día " + this.showHour(new Date()) + " por ";
        this.formSub.nombre = data.bodega.nombre_bodega;
        this.formSub.id = data.id;
        this.formSub.cantidaddepa = data.existencia;
      }

      // if (action == "ubicacion") {
      //   this.formget.departamentoId = data.departamentoId;
      //   this.formget.estante = data.estante;
      //   console.log(this.formget.estante);
      //   this.formget.pasillo = data.pasillo;
      //   this.formget.seccion = data.seccion;
      //   this.formget.id = data.id;
      //   this.selectOpc(1);
      // }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>
 <!-- Modal para Modelos-->
 <b-modal
            centered
            ref="modalModelos"
            id="modalModelos"
            title="Modelos"
            no-close-on-backdrop
            v-model="showModalM"
            @hidden="closeModal('modelos')"
            @show="openModal('modelos')"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
        >
          <form>
            <div class="row">

              <div class="col-12">
                <b-table-simple responsive>
                  <b-tbody>
                    <tr>
                      <th>Modelo</th>
                      <th>Estado</th>
                    </tr>
                  </b-tbody>
                  <tbody v-if="variosmodelos.length">
                  <tr v-for="(item, index) in variosmodelos" :key="index">

                    <td>{{ item.modelo.auto.nombre_auto }} {{ item.modelo.nombre_modelo }} {{ item.modelo.serie }} {{ item.modelo.linea }}</td>
                    <td><h5 v-if="item.estado_detalle == true">
                      <span class="badge bg-success ms-1"><strong>ACTIVO</strong></span>
                    </h5>
                      <h5 v-else>
                        <span class="badge bg-danger ms-1"><strong>INACTIVO</strong></span>
                      </h5>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else>
                  <tr style="background-color: #CEECF5;">
                    <td colspan="6">
                      No hay registros para mostrar.
                    </td>
                  </tr>
                  </tbody>
                </b-table-simple>
              </div>


            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalM = false">Cerrar</b-button>
            </div>
          </form>
        </b-modal>
        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar {{ this.formSub.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Desactivar {{ this.formSub.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <b-modal
          centered
          id="modalEditarExistencia"
          title="Editar existencia"
          title-class="text-black font-18"
        >
          <b-row>
            <b-col>
              <label>Existencia original</label>
              <h5>{{ datosExistencia.stockOriginal }}</h5>
            </b-col>
            <b-col>
              <label>Nueva existencia</label>
              <b-input
                v-model.trim="$v.datosExistencia.cantidad.$model"
                type="number"
                placeholder="Ingrese la cantidad"
                :class="{
                  'is-invalid': $v.datosExistencia.cantidad.$error,
                }"
              />
            </b-col>
          </b-row>
          <!-- <label>Razón</label> -->
          <!-- <b-input
            v-model="$v.datosExistencia.razon.$model"
            :class="{
              'is-invalid': $v.datosExistencia.razon.$error,
            }"
            placeholder="Ingrese la razón"
          >
          </b-input> -->
          <template #modal-footer="{}">
            <b-button variant="success" @click="editarExistencia()"
              >Guardar</b-button
            >
            <b-button
              variant="danger"
              @click="$bvModal.hide('modalEditarExistencia')"
              >Cerrar</b-button
            >
          </template>
        </b-modal>

        <!-- Modal para ubicacion fisica -->
        <b-modal
          centered
          v-model="showModalU"
          ref="modalUbicacion"
          id="modalUbicacion"
          title="Ubicación"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label>Estante</label>
                  <v-select
                    v-model.trim="$v.formget.estante.$model"
                    :state="!$v.formget.estante.$error"
                    :options="arrayEstante"
                    label="nombre_estante"
                  ></v-select>
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formget.estante.$error &&
                        !$v.formget.estante.required,
                    }"
                  >
                    Debe seleccionar un estante
                  </div>
                </div>
              </div>
              <div class="col-12">
                <!-- pasillo -->
                <div class="mb-3">
                  <label for="name">Pasillo</label>
                  <input
                    id="name"
                    v-model="$v.formget.pasillo.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un pasillo"
                    :class="{
                      'is-invalid': $v.formget.pasillo.$error,
                    }"
                    @input="$v.formget.pasillo.$touch()"
                  />
                  <div
                    v-if="
                      $v.formget.pasillo.$error && !$v.formget.pasillo.required
                    "
                    class="invalid-feedback"
                  >
                    El pasillo es necesaria.
                  </div>
                </div>
                <div class="mb-3">
                  <label for="name">Sección</label>
                  <input
                    id="name"
                    v-model="$v.formget.seccion.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una seccion"
                    :class="{
                      'is-invalid': $v.formget.seccion.$error,
                    }"
                    @input="$v.formget.seccion.$touch()"
                  />
                  <div
                    v-if="
                      $v.formget.seccion.$error && !$v.formget.seccion.required
                    "
                    class="invalid-feedback"
                  >
                    La seccion es necesaria.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalU = false"
                >Cancelar</b-button
              >
              <b-button variant="success" @click="validaciones('save')"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div class="text-center">
                    <div class="mb-4">
                      <a href="#" class="badge bg-light font-size-12">
                        <i
                          class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                        ></i>
                        Información del Producto
                      </a>
                    </div>
                    <div class="col-sm-4">
                        <div>
                          <router-link
                            :to="{
                              name: 'productos',
                            }"
                          >
                            <b-button
                              variant="outline-primary"
                              type="button"
                              class="btn btn-rounded mb-2 me-2"
                            >
                              <i class="mdi mdi-arrow-collapse-left"></i>
                              Regresar
                            </b-button>
                          </router-link>
                        </div>
                      </div>
                    <h4><strong>Producto</strong> </h4>
                  </div>
                  <div class="mb-4" v-if="datos.precio_venta">
                    <a href="#" class="badge bg-dark font-size-12">
                      <i
                        class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                      ></i>
                     <strong> Precio Venta: </strong>{{ money(datos.precio_venta) }}
                    </a>
                    <a href="#" class="badge bg-primary font-size-12">
                      <i
                        class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                      ></i>
                      <strong>Precio Compra:</strong>  {{ money(datos.precio_compra) }}
                    </a>
                    
                  </div>
                  
                  <hr />
                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2"><strong>Codigo</strong> </p>
                          <h5 class="font-size-15">{{ datos.codigo_stock }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Producto</strong> </p>
                          <h5 class="font-size-15" v-if="datos.nombre_producto">
                            {{ datos.nombre_producto }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Descripción</strong> </p>
                          <h5 class="font-size-15">
                            {{ datos.descripcion_producto }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-4" v-if="datos.marca">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Marca</strong> </p>
                          <h5 class="font-size-15">
                            {{ datos.marca.nombre_marca }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-4" v-if=" datos.categoria">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Categoría</strong> </p>
                          <h5 class="font-size-15">
                            {{ datos.categoria.nombre_categoria }}
                          </h5>
                        </div>
                      </div>
                    
                      <div class="col-sm-4">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Existencia</strong> </p>
                          <h5 class="font-size-15">
                            {{ datos.existencia_stock }}
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-3">
                        <div>
                          <p class="text-muted mb-2"><strong>Precio compra</strong> </p>
                          <h5
                            class="font-size-15"
                            v-if="datos.precio_compra"
                          >
                            {{ money(datos.precio_compra) }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Precio venta</strong> </p>
                          <h5 class="font-size-15">
                            {{ money(datos.precio_venta) }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Imagen producto</strong> </p>
                          <img
                              :src="(apiUrl + 'productos/get/imagen/' + datos.imagen_stock  )"
                              class="list-thumbnail responsive border-0 rounded-corners"
                              width="110%"
                            />
                        </div>
                      </div>
                      <!-- <div class="col-sm-2">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2"><strong>Autos</strong> </p>
                          <b-button
                              tabindex="0" v-b-tooltip.focus title="Ver Modelos" variant="outline-secondary"
                              @click="modelos_s()"
                          >
                            <i :class="'bx bxs-show'"/>
                          </b-button>
                        </div> -->
                      <!-- </div> -->
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Existencias</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="stock"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <!-- <b-but/ton
                      v-if="props.rowData.estado == true && userT.tienda == props.rowData.bodega.tiendaId"
                      variant="outline-danger
                   
                  "
                      @click="
                        onActionClicked('desactivate-item', props.rowData)
                      "
                    >
                      <i class="bx bx-trash-alt"></i>
                    </b-button> -->
                     <b-button
                      v-if="props.rowData.estado == true && userT.tienda == props.rowData.bodega.tiendaId"
                      v-b-modal.modalEditarExistencia
                      variant="outline-info
                   
                  "
                      @click="onActionClicked('edit-item', props.rowData)"
                    >
                      <i class="bx bx-shuffle"></i>
                    </b-button> 
                    <!--   <b-button v-if="props.rowData.estado"
                    tabindex="0" v-b-tooltip.focus title="Agregar Ubicacion"
                    @click="onActionClicked('ubicacion',props.rowData)"
                    v-b-modal.modalUbicacion
                    variant="outline-primary"
                    ><i :class="'bx bx-edit-alt'"
                  /></b-button>  -->
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>